import React from "react"
const TextInput = (props) => {
    return (
        <input
            className={`w-full outline-none appearance-none form-input rounded-none ${props.className} ${props.isCurserAllowed === true ? 'cursor-not-allowed bg-[#e9e9ea]  border-[#757575]  text-[#757575]' : ''}`}
            placeholder={props.placeholder}
            type={props.type}
            name={props.name}
            value={props.value}
            min={props.min}
            max={props.max}
            maxLength={props.maxLength}
            onChange={(event) => props.handleChange(event, props.identity)}
            onBlur={props.onBlur ? (e) => props.onBlur(props.identity) : undefined}
            disabled={props.disabled === true}
            autoComplete={props.autoComplete ? props.autoComplete : "off"}
        />
    );
}
export default TextInput;
